import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMTitleCard } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getPluralOfItemName } from "../../../utils/get-plural-of-item-name";
import { getProjectStatusBadge } from "../../../utils/get-project-status-badge";
import { makeGetCardCopy } from "../card-copy";

/** Adds the report title card (#2222). */
export function addTitleCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const titleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "titleComponent",
      labels: ["report-title"],
      title: getCardCopy(language, "reportTitle").title,
      description: getCardCopy(language, "reportTitle").description,
    },
  });

  titleComponent.mapState(
    ({ currentReport, settings, language, reportLayout }) => {
      const localizedLanguage = language || "en";
      const dynamicItemNamePlural = getPluralOfItemName(
        settings?.configuration?.itemName,
        localizedLanguage
      );
      const dashboardTabTitle =
        getLocalizedMessage(localizedLanguage, "dashboard") || "Dashboard";
      const reportTabs =
        reportLayout?.tabs && reportLayout.tabs.length > 0
          ? reportLayout.tabs
          : [
              { id: 0, title: dashboardTabTitle, rows: [] },
              { id: 1, title: dynamicItemNamePlural, rows: [] },
            ];
      const activeTabTitle =
        reportTabs[reportLayout?.activeTabIndex ?? 0]?.title ||
        dashboardTabTitle;

      return {
        title: `${activeTabTitle}: ${
          currentReport?.project?.customId
            ? currentReport.project.customId + " - "
            : ""
        }${currentReport?.project?.name ?? ""}`,

        showInfoIcon: false,
        showMenuIcon: false,
        badgeConfigs: [
          getProjectStatusBadge({
            currentReport,
            reportingCycle: settings?.configuration?.reportingCycle,
            language: localizedLanguage,
          }),
        ],
      };
    }
  );
}
